module.exports = __webpack_public_path__ + "static/media/logo512-removebg-preview.3ce6704c.png";